var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiagnosis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon11",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon",
    fill: "#F5F5F7",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 C18.209139,4 20,5.790861 20,8 L20,16 C20,18.209139 18.209139,20 16,20 L8,20 C5.790861,20 4,18.209139 4,16 L4,8 C4,5.790861 5.790861,4 8,4 L16,4 Z M16,6 L8,6 C6.8954305,6 6,6.8954305 6,8 L6,8 L6,16 C6,17.1045695 6.8954305,18 8,18 L8,18 L16,18 C17.1045695,18 18,17.1045695 18,16 L18,16 L18,8 C18,6.8954305 17.1045695,6 16,6 L16,6 Z",
    id: "Combined-Shape",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 11,
    y: 8,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 8,
    y: 8,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 11,
    y: 11,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 8,
    y: 11,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 11,
    y: 14,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006,
    x: 8,
    y: 14,
    width: 2,
    height: 2,
    rx: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiagnosis);
export default __webpack_public_path__ + "static/media/icon-diagnosis.4b80c3b0b68a2f7549739fcd9374f608.svg";
export { ForwardRef as ReactComponent };